module.exports = __webpack_public_path__ + "img/whiteLogo.7d9cfbd1.png";